import setCookie from './set-cookie';
import eraseCookie from './erase-cookie';

const setBookingCookie = (typeOfTravel: string) => {
  let queryData = '';
  if (window.location.href.split('/')[4].indexOf('#') > -1) {
    queryData = window.location.href.split('/')[4];
  } else {
    const tmpQryData = window.location.href.split('/')[4].split('-');
    tmpQryData.pop();
    queryData = '#' + tmpQryData.join('-');
  }
  let cookieName = 'query';
  if (typeOfTravel === 'international') {
    cookieName = 'queryinter';
  }
  eraseCookie(cookieName);
  setCookie(cookieName, queryData, '', '/', window.location.host.replace('www.', ''), '');
  eraseCookie('ys-' + cookieName);
  setCookie('ys-' + cookieName, queryData, '', '/', window.location.host.replace('www.', ''), '');
};

export default setBookingCookie;
